import type { ThemeOverrides } from "./types";

// Maps theme-override keys to the internal --_<alias> vars that dialog.css /
// trigger.css consume. Overriding the internal aliases directly (rather than
// --clr-*) means DB overrides win over both the host site's palette and our
// own fallbacks — that's the intended precedence.
const VAR_MAP: Record<keyof ThemeOverrides, string> = {
  base: "--_base",
  base2: "--_base-2",
  base3: "--_base-3",
  contrast: "--_contrast",
  contrast3: "--_contrast-3",
  accent1: "--_accent-1",
  accent2: "--_accent-2",
  dangerBase: "--_danger-base",
  dangerContrast: "--_danger-contrast",
  triggerBg: "--_trigger-bg",
  triggerFg: "--_trigger-fg",
};

// Permissive CSS color regex: covers #hex, rgb()/hsl()/hwb()/oklch()/color()
// and named colors. Rejects anything with quotes, braces, semicolons, or
// angle brackets so a malformed DB row can't break out of the :host {} block
// (defense in depth — DB is admin-only).
const SAFE_VALUE = /^[#a-zA-Z0-9 ,.()%/-]+$/;

export function themeOverridesCss(overrides: ThemeOverrides): string {
  const decls: string[] = [];
  for (const key of Object.keys(VAR_MAP) as (keyof ThemeOverrides)[]) {
    const value = overrides[key];
    if (typeof value === "string" && SAFE_VALUE.test(value)) {
      decls.push(`${VAR_MAP[key]}:${value}`);
    }
  }
  return decls.length ? `:host{${decls.join(";")}}` : "";
}
